import { supabase } from './supabase';

const PAGE_SIZE = 1000;

type FilterOperator = 'eq' | 'neq' | 'gte' | 'lte' | 'gt' | 'lt' | 'in';

export interface FetchAllRowsOptions {
  select?: string;
  orderBy?: {
    column: string;
    ascending?: boolean;
  };
  filters?: {
    column: string;
    op: FilterOperator;
    value: unknown;
  }[];
}

/**
 * Obtiene todas las filas de una tabla de Supabase por páginas para no perder
 * registros cuando una consulta supera el límite de 1,000 resultados.
 */
export async function fetchAllRows<T>(
  table: string,
  options: FetchAllRowsOptions = {}
): Promise<T[]> {
  const { select = '*', orderBy, filters = [] } = options;
  const rows: T[] = [];
  let offset = 0;

  while (true) {
    // La tabla se recibe dinámicamente; se mantiene el tipo flexible dentro de
    // esta utilidad para poder usar el mismo paginador en todas las tablas.
    let query: any = supabase.from(table).select(select);

    filters.forEach((filter) => {
      query = query[filter.op](filter.column, filter.value);
    });

    if (orderBy) {
      query = query.order(orderBy.column, {
        ascending: orderBy.ascending ?? true
      });
    }

    // Orden estable para impedir saltos o duplicados entre páginas cuando la
    // columna principal contiene valores repetidos.
    if (orderBy?.column !== 'id') {
      query = query.order('id', { ascending: true });
    }

    const { data, error } = await query.range(offset, offset + PAGE_SIZE - 1);
    if (error) throw error;

    const batch = (data ?? []) as T[];
    rows.push(...batch);

    if (batch.length < PAGE_SIZE) return rows;
    offset += PAGE_SIZE;
  }
}
